module.exports = __webpack_public_path__ + "img/SFJ0068.9c7e34a4.jpg";